export default __webpack_public_path__ + "static/vladyslav-zubko-6d5513f17b5115e482587923ca28d1b7.png";